export default {
  name: 'fw-download-file-button',
  fragment: {
      template: `<ribbon-button @tooltip text="toolbar.buttons.download" tooltip-title="toolbar.buttons.download" name="fw-download-file-button" icon-class="fv__icon-toolbar-download">toolbar.buttons.download</ribbon-button>`
  }
};